import ModuleWrapper from "./ModuleWrapper";

export default ModuleWrapper;